var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPremium)?_c('div',{staticClass:"ad-smp mb-2"},[_c('div',{ref:"ads"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }